export default __webpack_public_path__ + "static/media/bolt_filled-min.97d042d0.png";